import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { KeyingAuthService } from '../../../../../../apps/keycom/src/app/services/keying.auth.service'
import { NavService } from '../../../../../../apps/keycom/src/app/services/nav.service'
import { AppRoutingConfig } from '../../../../../../apps/keycom/src/app/configuration/app.routing.config'
import { User } from '@overtur-monorepo/keying-user'

@Component({
  selector: 'app-notification-management-container',
  templateUrl: './notification-management-container.component.html',
  styleUrls: ['./notification-management-container.component.scss'],
  standalone: false,
})
export class NotificationManagementContainerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()

  title = 'Notification Management'
  user!: User

  profileActions = [{ name: 'logout', icon: 'logout', id: 0 }]
  helpActions = [{ name: 'Support', icon: 'user', id: 0 }]
  navButtons = [{ name: 'Home', active: true, icon: 'home', router: AppRoutingConfig.structuresUrl }]

  constructor(
    private authService: KeyingAuthService,
    private navService: NavService,
  ) {}

  ngOnInit(): void {
    this.navService.setEntities(this.navButtons)

    this.authService.keyingUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user) {
        this.user = user
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  helpAction(_action: any): void {} // NOSONAR

  profileAction(action: any): void {
    if (action.id === 0) {
      this.authService.logout()
    }
  }
}
